import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions } from 'actions'
import { SEOSettingsStore } from 'stores'
import { SettingsPage } from 'pages'

@connectToStores
export default class SettingsContainer extends React.Component {
  static getStores() {
    return [
      SEOSettingsStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState()
    }
  }

  componentWillMount() {
    if (!this.props.settings) {
      SEOSettingsActions.fetch()
    }
  }

  render() {
    return (
      <SettingsPage
        settings={this.props.settings}
        fetching={this.props.fetching}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/plus/SettingsContainer.js